import { render, staticRenderFns } from "./home_Tab.vue?vue&type=template&id=0a72e530&scoped=true&"
import script from "./home_Tab.vue?vue&type=script&lang=js&"
export * from "./home_Tab.vue?vue&type=script&lang=js&"
import style0 from "./home_Tab.vue?vue&type=style&index=0&id=0a72e530&prod&lang=less&scoped=true&"
import style1 from "./home_Tab.vue?vue&type=style&index=1&id=0a72e530&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a72e530",
  null
  
)

export default component.exports